//src/redux/reducers.js

import { combineReducers } from "redux";
import authReducer from "./authReducer";
import createAccountReducer from "./createAccountReducer";
import navigationReducer from "./navigationReducer";
import scormReducer from "./scormReducer";
import wallReducer from "./wallReducer";
import accountReducer from "./accountReducer";
import accountCoursesFilter from "./accountCoursesFilter";
import configReducer from "./configReducer";
import storeReducer from "./storeReducer";
import newsReducer from "./newsReducer";
import brandsReducer from "./brandsReducer";
import formationsReducer from "./formationsReducer";
import searchReducer from "./searchReducer";
import notificationReducer from "./notificationReducer";
import interstitialReducer from "./interstitialReducer";
import optanonReducer from "./optanonReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  account: accountReducer,
  createAccount: createAccountReducer,
  navigation: navigationReducer,
  scorm: scormReducer,
  wallFilters: wallReducer,
  accountFilters: accountCoursesFilter,
  config: configReducer,
  store: storeReducer,
  news: newsReducer,
  brands: brandsReducer,
  formations: formationsReducer,
  searchFilters: searchReducer,
  notifications: notificationReducer,
  interstitial: interstitialReducer,
  optanon: optanonReducer,
});

export default rootReducer;
